import {useId} from "react";
import {Controller, UseControllerProps, useFormContext} from "react-hook-form";

import {ISelectFieldProps, SelectCreatableField} from "@pg-design/select-field-module";

type IProps = Omit<ISelectFieldProps, "value"> & {
    name: string;
    rules?: UseControllerProps["rules"];
};

export function SelectCreatableFieldControlled(props: IProps) {
    const {name, rules, ...selectFieldProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            render={({field, fieldState: {error}}) => {
                const fieldError = error && error.message;
                const {ref: _ref, ...fieldProps} = field;

                return <SelectCreatableField {...fieldProps} {...selectFieldProps} value={field.value} error={fieldError} instanceId={useId()} />;
            }}
        />
    );
}
import {useId} from "react";
import {Controller, UseControllerProps, useFormContext} from "react-hook-form";

import {ISelectFieldProps, SelectCreatableField} from "@pg-design/select-field-module";

type IProps = Omit<ISelectFieldProps, "value"> & {
    name: string;
    rules?: UseControllerProps["rules"];
};

export function SelectCreatableFieldControlled(props: IProps) {
    const {name, rules, ...selectFieldProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            render={({field, fieldState: {error}}) => {
                const fieldError = error && error.message;
                const {ref: _ref, ...fieldProps} = field;

                return <SelectCreatableField {...fieldProps} {...selectFieldProps} value={field.value} error={fieldError} instanceId={useId()} />;
            }}
        />
    );
}
